import { NgModule } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { AdminRoutingModule } from './admin-routing.module';
import { SharedModule } from '@app/shared-module/shared-module.module';
import { RepaymentDetailsComponent } from './repayment-details/repayment-details.component';
import { TransactionListComponent } from './transaction-list/transaction-list.component';
import { BoardingSpaComponent } from './boarding-spa/boarding-spa.component';
import { TransactionDashboardComponent } from './transaction-dashboard/transaction-dashboard.component';
import { AdminHomeComponent } from './admin-home/admin-home.component';
import { AddInternalUserComponent } from './add-internal-user/add-internal-user.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { LinechartComponent } from './line-chart/line-chart.component';
import { PiechartComponent } from './pie-chart/piechart.component';
import { UpdatePaymentComponent } from './update-payment/update-payment.component';
import { HardResetPasswordComponent } from './hard-reset-password/hard-reset-password.component';

@NgModule({
  declarations: [
    RepaymentDetailsComponent,
    TransactionListComponent,
    BoardingSpaComponent,
    TransactionDashboardComponent,
    AdminHomeComponent,
    AddInternalUserComponent,
    ChangepasswordComponent,
    LinechartComponent,
    PiechartComponent,
    UpdatePaymentComponent,
    HardResetPasswordComponent
  ],
  imports: [
    SharedModule,
    AdminRoutingModule
  ],
  providers: [
    AdminService
  ],
  entryComponents: [
    AddInternalUserComponent,
    ChangepasswordComponent,
    LinechartComponent,
    PiechartComponent,
    UpdatePaymentComponent
  ]
})
export class AdminModuleModule { }
